import { connect } from "react-redux";
import { QuestionFooter as Component } from "./QuestionFooter";
import {
  submitQuestionAnswer,
  saveTaskNote,
} from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps() {
  return {
    interactionProps: {
      solutions: null,
    },
    DNAkey: null,
    uuid: null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    submitAnswer: (id, type, saveTaskNote) =>
      dispatch(submitQuestionAnswer(id, type, saveTaskNote)),
    saveTaskNote: (data) => dispatch(saveTaskNote(data)),
  };
}

export const QuestionFooter = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
